var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 1C5.485 1 1 5.485 1 11s4.485 10 10 10 10-4.485 10-10S16.515 1 11 1zm0 1.333A8.661 8.661 0 0 1 19.672 11 8.665 8.665 0 0 1 11 19.672 8.661 8.661 0 0 1 2.333 11 8.657 8.657 0 0 1 11 2.333zm-.01 3.337a.667.667 0 0 0-.654.675v.561c-1.076.202-1.997.895-1.997 2.097 0 .833.375 1.507.88 1.9.504.392 1.074.566 1.574.732.5.167.932.326 1.177.517.246.191.363.352.363.852 0 1.111-2.661 1.111-2.661 0a.667.667 0 1 0-1.333 0c0 1.2.921 1.895 1.997 2.098v.558a.667.667 0 1 0 1.333 0v-.558c1.076-.203 1.999-.898 1.999-2.098 0-.833-.377-1.507-.882-1.9-.504-.392-1.074-.568-1.574-.734-.5-.167-.931-.325-1.177-.516-.245-.19-.363-.351-.363-.851 0-1.112 2.661-1.112 2.661 0a.667.667 0 1 0 1.335 0c0-1.2-.923-1.892-1.999-2.095v-.563a.667.667 0 0 0-.678-.675z",
    fill: "#F6B119",
    fillRule: "nonzero",
    stroke: "#F6B119",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.6f38860618ebc856a67225df577787e6.svg";
export { ForwardRef as ReactComponent };